exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-container{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}.typewriter{font-size:1rem;margin-top:3px;display:inline-block;overflow:hidden;border-right:.08em solid #333;white-space:pre-wrap;letter-spacing:.15em;animation:typing 3.5s steps(40)}", ""]);

// exports
